var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable max-len */
import React from 'react';
import ResidentTable from './component/ResidentTable';
import { Box, Button, Checkbox, ListItemText, Menu, MenuItem, TextField, Typography, Tooltip, } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { API_LOAD_STATE, CareInsightStatus, PAGINATION_TYPE, PaginationFetchTypes, Roles, } from 'globals/enums';
import withPaginationTable from 'hoc/withPaginationIsolated/withPaginationTable';
import { SENIOR_HOME_SEARCH, SET_SENIOR_PAUSE_FILTER, getSeniorList, getSeniorListFail, getSeniorListSuccess, getSeniorSearchListSuccess, resetHomeSearch, resetSeniorList, searchSeniorByName, showError, updateSeniorListPageNumber, } from 'store/commonReducer/common.action';
import { AllResidentsStyle } from './AllResidents.style';
import { PAGINATION_LIMIT, facilitySlugs } from 'globals/global.constants';
import { useParams } from 'react-router-dom';
import { RESET_CARE_AGENTS } from 'pages/WCPages/Admin/Accounts/AgentAccount/CareAgentAccount.actions';
import { RESET_SENIOR_LIST_ADMINS } from 'pages/WCPages/Admin/Accounts/CWMemberRecords/CWMemberRecords.actions';
import FacilityDetailHeader from 'common/FacilityDetailHeader/FacilityDetailHeader';
import { useMutation, useQuery } from 'utilities/react-query';
import { getAllFacilityCareInsightEventsService, putAcknowledgeCareInsights, } from 'services/careInsightService/insightSummary.service';
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
import { removeFacilitySummary } from 'store/eventsReducer/Events.action';
import { SET_FACILITY_TYPE_FILTER } from 'pages/WCPages/Admin/CorporateAndFacilities/FacilityManagement/FacilityManagement.action';
import { capitalizeFirstLetter } from 'globals/global.functions';
import InfoIcon from '@mui/icons-material/Info';
import { getCareAgentService } from 'services/deviceInfoService/deviceInfo.service';
var PAUSE_STATUS_OPTIONS = [
    { label: 'Paused', value: 'Paused' },
    { label: 'Unpaused', value: 'Unpaused' },
];
var AllResidents = function () {
    var classes = AllResidentsStyle().classes;
    var selectedWc = useAppSelector(function (state) { return state.common.seniorList.selectedHomeWc; });
    var facilityTypes = useAppSelector(function (state) {
        return state.corporateAndFacilities.facilityManagementData.selectedFacility
            .facilityType;
    });
    var selectedFacilityType = useAppSelector(function (state) {
        return state.corporateAndFacilities.facilityManagementData.facilityTypeFilter;
    });
    var agentFacilityType = useAppSelector(function (state) { var _a; return ((_a = state.auth.facilityDetails) === null || _a === void 0 ? void 0 : _a.facility_type) || ''; });
    var pauseStatusValue = useAppSelector(function (state) { return state.common.seniorList.pauseStatusFilter; });
    var _a = React.useState(null), filterMenuAnchor = _a[0], setFilterMenuAnchor = _a[1];
    var _b = React.useState(null), activeFilter = _b[0], setActiveFilter = _b[1];
    var _c = React.useState([]), coachOptions = _c[0], setCoachOptions = _c[1];
    var _d = React.useState(false), isCoachOptionsLoading = _d[0], setIsCoachOptionsLoading = _d[1];
    var _e = React.useState(function () { return ((selectedWc === null || selectedWc === void 0 ? void 0 : selectedWc.userId) ? [String(selectedWc.userId)] : []); }), selectedCoachIds = _e[0], setSelectedCoachIds = _e[1];
    var _f = React.useState(function () {
        return selectedFacilityType ? [selectedFacilityType] : [];
    }), selectedFacilityTypes = _f[0], setSelectedFacilityTypes = _f[1];
    var _g = React.useState(false), isCoachAllDeselected = _g[0], setIsCoachAllDeselected = _g[1];
    var _h = React.useState(false), isFacilityTypeAllDeselected = _h[0], setIsFacilityTypeAllDeselected = _h[1];
    var _j = React.useState(false), isPauseAllDeselected = _j[0], setIsPauseAllDeselected = _j[1];
    var _k = React.useState(''), coachSearchText = _k[0], setCoachSearchText = _k[1];
    var facilityTypeOption = React.useMemo(function () {
        var facilityName = agentFacilityType;
        if (agentFacilityType === 'memory_care') {
            facilityName = 'home_care';
        }
        return facilityName
            .split('_')
            .map(function (x) { return capitalizeFirstLetter(x, true); })
            .join(' ');
    }, [agentFacilityType]);
    var dispatch = useAppDispatch();
    var params = useParams();
    var userRole = useAppSelector(function (state) { return state.auth.userRole; });
    var pusherData = useAppSelector(function (state) { return state.events.facilitySummary || []; });
    sessionStorage.setItem('currentFacilityType', facilityTypeOption);
    var _l = React.useState(false), isUnauthorized = _l[0], setIsUnauthorized = _l[1];
    // query to get facility summary highlight data
    var _m = useQuery({
        queryKey: ['facilitySummaryData'],
        queryFn: function () {
            return getAllFacilityCareInsightEventsService({
                facility_id: params[facilitySlugs.facilityHomePage] || '',
                status: CareInsightStatus.Approved,
            });
        },
        cacheTime: 0,
        enabled: userRole.includes(Roles.FACILITY_AGENT),
    }).data, data = _m === void 0 ? [] : _m;
    // Replace these two selectors
    var facilityListData = useAppSelector(function (state) { return state.common.seniorList.data; });
    var facilityListLoading = useAppSelector(function (state) { return state.common.seniorList.loading; });
    React.useEffect(function () {
        var isActive = true;
        var loadCoaches = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, cursor, seenCursors, page, response, nextCursor, cursorKey, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsCoachOptionsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        results = [];
                        cursor = void 0;
                        seenCursors = new Set();
                        page = 0;
                        _a.label = 2;
                    case 2:
                        if (!(page < 100)) return [3 /*break*/, 5];
                        return [4 /*yield*/, getCareAgentService(__assign({ role: Roles.CareAgent }, (cursor ? { last_evaluated_key: cursor } : {})))];
                    case 3:
                        response = _a.sent();
                        results.push.apply(results, ((response === null || response === void 0 ? void 0 : response.result) || []).filter(function (coach) { var _a; return (coach === null || coach === void 0 ? void 0 : coach.userId) && ((_a = coach === null || coach === void 0 ? void 0 : coach.assignedSenior) === null || _a === void 0 ? void 0 : _a.length); }));
                        nextCursor = response === null || response === void 0 ? void 0 : response.lastEvaluatedKey;
                        cursorKey = JSON.stringify(nextCursor);
                        if (!nextCursor || seenCursors.has(cursorKey))
                            return [3 /*break*/, 5];
                        seenCursors.add(cursorKey);
                        cursor = nextCursor;
                        _a.label = 4;
                    case 4:
                        page += 1;
                        return [3 /*break*/, 2];
                    case 5:
                        if (isActive) {
                            setCoachOptions(Array.from(new Map(results.map(function (coach) { return [coach.userId, coach]; })).values()));
                        }
                        return [3 /*break*/, 8];
                    case 6:
                        error_1 = _a.sent();
                        if (isActive)
                            dispatch(showError(error_1));
                        return [3 /*break*/, 8];
                    case 7:
                        if (isActive)
                            setIsCoachOptionsLoading(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        loadCoaches();
        return function () {
            isActive = false;
        };
    }, [dispatch]);
    React.useEffect(function () {
        return function () {
            dispatch(resetSeniorList());
            dispatch({ type: RESET_CARE_AGENTS });
            dispatch({ type: RESET_SENIOR_LIST_ADMINS });
            dispatch(resetHomeSearch());
        };
    }, [dispatch]);
    var facilityId = params[facilitySlugs.facilityHomePage];
    var isFacilityTypeFilterAvailable = userRole.includes(Roles.Admin) ||
        userRole.includes(Roles.Admin_WellnessServices);
    var isFacilityAgent = userRole.includes(Roles.FACILITY_AGENT);
    var isCoachAllSelected = !isCoachAllDeselected && selectedCoachIds.length === 0;
    var isFacilityTypeAllSelected = !isFacilityTypeAllDeselected && selectedFacilityTypes.length === 0;
    var isPauseAllSelected = !isPauseAllDeselected && !pauseStatusValue;
    var availableFacilityTypes = isFacilityAgent
        ? [facilityTypeOption]
        : facilityTypes;
    var toggleCoach = function (coachId) {
        var allIds = coachOptions.map(function (coach) { return String(coach.userId); });
        var nextIds = isCoachAllSelected
            ? allIds.filter(function (id) { return id !== coachId; })
            : isCoachAllDeselected
                ? [coachId]
                : selectedCoachIds.includes(coachId)
                    ? selectedCoachIds.filter(function (id) { return id !== coachId; })
                    : __spreadArray(__spreadArray([], selectedCoachIds, true), [coachId], false);
        if (!nextIds.length) {
            setSelectedCoachIds([]);
            setIsCoachAllDeselected(true);
            return;
        }
        if (allIds.length && nextIds.length === allIds.length) {
            setSelectedCoachIds([]);
            setIsCoachAllDeselected(false);
            return;
        }
        setSelectedCoachIds(nextIds);
        setIsCoachAllDeselected(false);
    };
    var toggleFacilityType = function (facilityType) {
        var nextTypes = isFacilityTypeAllSelected
            ? availableFacilityTypes.filter(function (type) { return type !== facilityType; })
            : isFacilityTypeAllDeselected
                ? [facilityType]
                : selectedFacilityTypes.includes(facilityType)
                    ? selectedFacilityTypes.filter(function (type) { return type !== facilityType; })
                    : __spreadArray(__spreadArray([], selectedFacilityTypes, true), [facilityType], false);
        if (!nextTypes.length) {
            setSelectedFacilityTypes([]);
            setIsFacilityTypeAllDeselected(true);
            return;
        }
        if (availableFacilityTypes.length &&
            nextTypes.length === availableFacilityTypes.length) {
            setSelectedFacilityTypes([]);
            setIsFacilityTypeAllDeselected(false);
            return;
        }
        setSelectedFacilityTypes(nextTypes);
        setIsFacilityTypeAllDeselected(false);
    };
    var togglePauseStatus = function (status) {
        var selectedStatuses = isPauseAllDeselected
            ? []
            : pauseStatusValue
                ? [pauseStatusValue]
                : PAUSE_STATUS_OPTIONS.map(function (option) { return option.value; });
        var nextStatuses = isPauseAllSelected
            ? PAUSE_STATUS_OPTIONS
                .filter(function (option) { return option.value !== status; })
                .map(function (option) { return option.value; })
            : selectedStatuses.includes(status)
                ? selectedStatuses.filter(function (value) { return value !== status; })
                : __spreadArray(__spreadArray([], selectedStatuses, true), [status], false);
        if (!nextStatuses.length) {
            setIsPauseAllDeselected(true);
            return;
        }
        setIsPauseAllDeselected(false);
        dispatch({
            type: SET_SENIOR_PAUSE_FILTER,
            payload: nextStatuses.length === PAUSE_STATUS_OPTIONS.length
                ? ''
                : nextStatuses[0],
        });
    };
    var toggleAllPauseStatuses = function () {
        if (isPauseAllSelected) {
            setIsPauseAllDeselected(true);
            return;
        }
        setIsPauseAllDeselected(false);
        dispatch({ type: SET_SENIOR_PAUSE_FILTER, payload: '' });
    };
    var handleResetFilters = function () {
        setSelectedCoachIds([]);
        setSelectedFacilityTypes([]);
        setIsCoachAllDeselected(false);
        setIsFacilityTypeAllDeselected(false);
        setIsPauseAllDeselected(false);
        setCoachSearchText('');
        setActiveFilter(null);
        setFilterMenuAnchor(null);
        dispatch({ type: SET_FACILITY_TYPE_FILTER, payload: '' });
        dispatch({ type: SET_SENIOR_PAUSE_FILTER, payload: '' });
    };
    React.useEffect(function () {
        if (facilityListLoading !== API_LOAD_STATE.SUCCESSFUL)
            return;
        if (!facilityId) {
            setIsUnauthorized(true);
            return;
        }
        if (!Array.isArray(facilityListData)) {
            setIsUnauthorized(true);
            return;
        }
        if (facilityListData.length === 0)
            return;
        var isValidFacility = facilityListData.some(function (rowData) {
            return String(rowData.minimal.facility_id) === String(facilityId);
        });
        // setIsUnauthorized(!isValidFacility);
    }, [facilityListData, facilityListLoading, facilityId]);
    // mutation to acknowledge facility summary notification for a senior
    var acknowledgeSummaryMutation = useMutation({
        mutationFn: function (params) {
            dispatch(showApplicationLoader());
            return putAcknowledgeCareInsights(params);
        },
        onSuccess: function () {
            dispatch(hideApplicationLoader());
        },
        onError: function (error) {
            dispatch(hideApplicationLoader());
            dispatch(showError(error));
        },
    });
    // ✅ Stable highlight data using JSON.stringify to prevent unnecessary re-renders
    var highlightData = React.useMemo(function () {
        return __spreadArray(__spreadArray([], pusherData, true), data, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(pusherData), JSON.stringify(data)]);
    // HOC props
    var withPaginationProps = React.useMemo(function () {
        var commonProps = {
            getData: function (searchQuery, lastEvaluatedKey) {
                return getSeniorList(searchQuery, lastEvaluatedKey, [], null, false, '', true, true, '', params[facilitySlugs.facilityHomePage], true, pauseStatusValue, selectedCoachIds, isFacilityAgent ? [facilityTypeOption] : selectedFacilityTypes);
            },
            onSuccess: getSeniorListSuccess,
            onError: getSeniorListFail,
            onSearchSuccess: getSeniorSearchListSuccess,
            lastEvaluatedKeyPath: 'common.seniorList.lastEvaluatedKey',
            tableDataPath: 'common.seniorList.data',
            loadingPath: 'common.seniorList.loading',
        };
        return {
            fetchType: PaginationFetchTypes.LAST_EVALUATED_KEY,
            debounceDelay: 1000,
            // constructing dependency using all possible filter values
            dependency: JSON.stringify([
                selectedCoachIds,
                isFacilityAgent ? facilityTypeOption : selectedFacilityTypes,
                pauseStatusValue,
                params[facilitySlugs.facilityHomePage],
            ]),
            paginationProps: __assign(__assign({}, commonProps), { onPageChange: updateSeniorListPageNumber, rowsPerPage: PAGINATION_LIMIT.residentsPage, className: classes.pagination, paginationType: PAGINATION_TYPE.PRIMARY, tableDataPath: 'common.seniorList.data', isScrollOnTop: true, pagePath: 'common.seniorList.currentPage', searchLastEvaluatedKeyPath: 'common.seniorList.searchLastEvaluatedKey' }),
            searchBarProps: __assign(__assign({}, commonProps), { onSearchChange: function (value) {
                    dispatch({ type: SENIOR_HOME_SEARCH, payload: value }); // will trigger with debounce
                }, className: classes.searchContainer, searchMethod: searchSeniorByName, disableFrontendSearch: true, noRightMargin: true, renderLeftSideComponent: function (isDataLoading) {
                    var isDisabled = isDataLoading === API_LOAD_STATE.PROGRESS ||
                        isCoachOptionsLoading;
                    var visibleCoachOptions = coachOptions.filter(function (coach) {
                        var _a;
                        return (_a = coach.fullName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(coachSearchText.toLowerCase());
                    });
                    var filters = __spreadArray(__spreadArray([
                        { key: 'coach', label: 'Wellness Coach' }
                    ], (isFacilityTypeFilterAvailable
                        ? [{ key: 'facilityType', label: 'Facility Type' }]
                        : []), true), (isFacilityTypeFilterAvailable
                        ? [{ key: 'pauseStatus', label: 'Pause Status' }]
                        : []), true);
                    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Button, { variant: 'contained', color: 'primary', onClick: function (event) {
                                    event.stopPropagation();
                                    setFilterMenuAnchor(event.currentTarget);
                                }, endIcon: _jsx(KeyboardArrowDownIcon, {}), children: "Select Filters" }), _jsx(Menu, { anchorEl: filterMenuAnchor, open: Boolean(filterMenuAnchor), onClose: function () {
                                    setFilterMenuAnchor(null);
                                    setActiveFilter(null);
                                }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, MenuListProps: {
                                    sx: {
                                        maxHeight: 'min(420px, calc(100vh - 200px))',
                                        overflowY: 'auto',
                                        minWidth: 240,
                                    },
                                }, PaperProps: {
                                    sx: {
                                        maxHeight: 'min(420px, calc(100vh - 200px))',
                                        overflowY: 'auto',
                                    },
                                }, children: filters.map(function (filter, index) { return (_jsxs(React.Fragment, { children: [_jsxs(MenuItem, { onClick: function () {
                                                return setActiveFilter(function (current) {
                                                    return current === filter.key ? null : filter.key;
                                                });
                                            }, sx: {
                                                justifyContent: 'space-between',
                                                fontWeight: activeFilter === filter.key ? 700 : 500,
                                                backgroundColor: activeFilter === filter.key ? '#F1F7ED' : '#fff',
                                                borderTop: index ? '1px solid #e0e0e0' : 'none',
                                            }, children: [filter.label, _jsx(KeyboardArrowDownIcon, { fontSize: 'small', sx: {
                                                        transform: activeFilter === filter.key
                                                            ? 'rotate(180deg)'
                                                            : 'none',
                                                    } })] }), activeFilter === filter.key && (_jsxs(Box, { sx: {
                                                px: 1.5,
                                                py: 1,
                                                ml: 2,
                                                minWidth: 300,
                                                backgroundColor: '#F8FAF6',
                                                borderLeft: '2px solid #6BA539',
                                            }, onClick: function (event) { return event.stopPropagation(); }, onKeyDown: function (event) { return event.stopPropagation(); }, children: [filter.key === 'coach' && (_jsxs(_Fragment, { children: [_jsx(TextField, { size: 'small', fullWidth: true, placeholder: 'Search wellness coaches', value: coachSearchText, onChange: function (event) {
                                                                return setCoachSearchText(event.target.value);
                                                            }, sx: { mb: 1 } }), _jsxs(MenuItem, { selected: isCoachAllSelected, disabled: isDisabled, onClick: function () {
                                                                if (isCoachAllSelected) {
                                                                    setIsCoachAllDeselected(true);
                                                                    return;
                                                                }
                                                                var forceRefresh = isCoachAllDeselected &&
                                                                    !selectedCoachIds.length;
                                                                setSelectedCoachIds([]);
                                                                setIsCoachAllDeselected(false);
                                                            }, children: [_jsx(Checkbox, { checked: isCoachAllSelected, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), _jsx(ListItemText, { primary: 'All Wellness Coaches' })] }), visibleCoachOptions.map(function (coach) {
                                                            var checked = isCoachAllSelected ||
                                                                (!isCoachAllDeselected &&
                                                                    selectedCoachIds.includes(String(coach.userId)));
                                                            return (_jsxs(MenuItem, { selected: checked, disabled: isDisabled, onClick: function () {
                                                                    return toggleCoach(String(coach.userId));
                                                                }, children: [_jsx(Checkbox, { checked: checked, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), _jsx(ListItemText, { primary: coach.fullName })] }, coach.userId));
                                                        })] })), filter.key === 'facilityType' && (_jsxs(_Fragment, { children: [_jsxs(MenuItem, { selected: isFacilityTypeAllSelected, disabled: isDisabled, onClick: function () {
                                                                if (isFacilityTypeAllSelected) {
                                                                    setIsFacilityTypeAllDeselected(true);
                                                                    return;
                                                                }
                                                                var forceRefresh = isFacilityTypeAllDeselected &&
                                                                    !selectedFacilityTypes.length;
                                                                setSelectedFacilityTypes([]);
                                                                setIsFacilityTypeAllDeselected(false);
                                                            }, children: [_jsx(Checkbox, { checked: isFacilityTypeAllSelected, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), _jsx(ListItemText, { primary: 'All Facility Types' })] }), facilityTypes.map(function (facilityType) {
                                                            var checked = isFacilityTypeAllSelected ||
                                                                (!isFacilityTypeAllDeselected &&
                                                                    selectedFacilityTypes.includes(facilityType));
                                                            return (_jsxs(MenuItem, { selected: checked, disabled: isDisabled, onClick: function () {
                                                                    return toggleFacilityType(facilityType);
                                                                }, children: [_jsx(Checkbox, { checked: checked, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), _jsx(ListItemText, { primary: facilityType })] }, facilityType));
                                                        })] })), filter.key === 'pauseStatus' && (_jsxs(_Fragment, { children: [_jsxs(MenuItem, { selected: isPauseAllSelected, disabled: isDataLoading === API_LOAD_STATE.PROGRESS, onClick: toggleAllPauseStatuses, children: [_jsx(Checkbox, { checked: isPauseAllSelected, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), _jsx(ListItemText, { primary: 'All Status' })] }), PAUSE_STATUS_OPTIONS.map(function (option) {
                                                            var checked = isPauseAllSelected ||
                                                                (!isPauseAllDeselected &&
                                                                    pauseStatusValue === option.value);
                                                            return (_jsxs(MenuItem, { selected: checked, disabled: isDataLoading === API_LOAD_STATE.PROGRESS, onClick: function () {
                                                                    return togglePauseStatus(option.value);
                                                                }, children: [_jsx(Checkbox, { checked: checked, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), _jsx(ListItemText, { primary: option.label })] }, option.value));
                                                        })] }))] }))] }, filter.key)); }) }), _jsx(Button, { variant: 'contained', color: 'primary', disabled: isDataLoading === API_LOAD_STATE.PROGRESS, onClick: handleResetFilters, children: "Reset Filters" })] }));
                } }),
        };
    }, [
        params[facilitySlugs.facilityHomePage],
        isFacilityAgent,
        facilityTypeOption,
        facilityTypes,
        selectedCoachIds,
        selectedFacilityTypes,
        pauseStatusValue,
        filterMenuAnchor,
        activeFilter,
        coachOptions,
        coachSearchText,
        isCoachOptionsLoading,
        isCoachAllDeselected,
        isFacilityTypeAllDeselected,
        isPauseAllDeselected,
    ]);
    var withPaginationPropsRef = React.useRef(null);
    withPaginationPropsRef.current = withPaginationProps;
    var seniorWCMappingWithPagination = React.useMemo(function () {
        return withPaginationTable(ResidentTable, {
            isHighlighted: function (record) {
                if (userRole.includes(Roles.FACILITY_AGENT)) {
                    var highlights = (highlightData === null || highlightData === void 0 ? void 0 : highlightData.filter(function (summary) { return summary.seniorId === record.senior_id; })) || [];
                    return !!highlights.length;
                }
                return false;
            },
            onRowClick: function (rowData) {
                if (userRole.includes(Roles.FACILITY_AGENT)) {
                    var highlights = (highlightData === null || highlightData === void 0 ? void 0 : highlightData.filter(function (summary) { return summary.seniorId === rowData.senior_id; })) || [];
                    var careInsightIds = highlights.map(function (summary) { return summary.careInsightId; });
                    dispatch(removeFacilitySummary(careInsightIds));
                    acknowledgeSummaryMutation.mutate({
                        senior_id: rowData.senior_id,
                        account_id: rowData.account_id,
                        care_insight_id: careInsightIds,
                    });
                }
            },
        }, withPaginationProps, withPaginationPropsRef);
    }, [JSON.stringify(highlightData), userRole]);
    var TableComponent = seniorWCMappingWithPagination;
    var tooltipText = (_jsxs(React.Fragment, { children: [_jsx(Typography, { variant: 'h3', component: 'div', sx: { fontWeight: 'bold' }, children: "Your All-In-One Dashboard" }), _jsx(Typography, { component: 'div', children: "Unlock a wealth of client information, progress tracking, and direct communication with wellness coaches through this comprehensive dashboard. Stay informed, motivated, and connected every step of the way." })] }));
    // if (isUnauthorized) {
    //   return <UnauthorizedAccess />;
    // }
    return (_jsxs(Box, { children: [_jsx(FacilityDetailHeader, { isFacilityButton: true }), _jsx(Box, { className: classes.paginationTableContainer, children: _jsxs(Box, { className: classes.title, style: { display: 'inline-flex' }, children: [_jsx(Typography, { component: 'div', variant: 'h2', children: "Clients" }), _jsx(Tooltip, { title: tooltipText, children: _jsx(Box, { children: _jsx(InfoIcon, { style: { marginLeft: '8px', height: '24px', width: '24px' } }) }) })] }) }), _jsx(TableComponent, {})] }));
};
export default AllResidents;
